"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Checkbox = _interopRequireDefault(require("../../Checkbox"));
var _Switch = _interopRequireDefault(require("../../Switch"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var styles = function styles(theme) {
  return {
    disabled: {
      color: theme.palette.opacity.black[38],
      cursor: 'default'
    },
    menuItem: {
      backgroundColor: '#f5f5f5',
      boxSizing: 'content-box',
      // MaterialUI v4 fix
      color: theme.palette.text.primary,
      fontSize: 13,
      fontWeight: 400,
      lineHeight: '20px',
      paddingBottom: 11,
      // MaterialUI V4 fix
      paddingLeft: 8,
      paddingTop: 11 // MaterialUI V4 fix
    },

    "switch": {
      alignItems: 'center',
      display: 'flex',
      marginLeft: 'auto'
    }
  };
};
var OptionListHeader = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(OptionListHeader, _React$Component);
  var _super = _createSuper(OptionListHeader);
  function OptionListHeader() {
    var _this;
    (0, _classCallCheck2["default"])(this, OptionListHeader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.toggleSelectAll = function (selectAllSelected, options) {
      var handleSelectAll = _this.props.componentProps.handleSelectAll;
      handleSelectAll(!selectAllSelected, options);
    };
    _this.toggleViewSelected = function (e, newValue) {
      var componentProps = _this.props.componentProps;
      var handleViewSelected = componentProps.handleViewSelected;
      handleViewSelected(newValue);
    };
    _this.countOptions = function (options) {
      var isGroup = _this.props.componentProps.isGroup;
      // Count options/child options and ignore group
      return Array.isArray(options) ? options.filter(function (opt) {
        return !isGroup(opt) && !opt.isDisabled;
      }).length : 0;
    };
    return _this;
  }
  (0, _createClass2["default"])(OptionListHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        componentProps = _this$props.componentProps,
        commonProps = _this$props.commonProps,
        classes = _this$props.classes,
        isActionFooter = _this$props.isActionFooter,
        handleChangeFocus = _this$props.handleChangeFocus;
      var showOptionListHeader = componentProps.showOptionListHeader,
        selectSwitchLabelText = componentProps.selectSwitchLabelText;
      var automationid = commonProps.automationid,
        dataMetrics = commonProps.dataMetrics,
        options = commonProps.options,
        value = commonProps.value,
        isAsync = commonProps.isAsync,
        searchInputValue = commonProps.searchInputValue,
        viewSelectedEnabled = commonProps.viewSelectedEnabled;
      var optionCount = this.countOptions(options);
      var valueCount = this.countOptions(value);
      var selectAllSelected = valueCount === optionCount;
      var someOptionsSelected = Array.isArray(value) && value.length > 0;
      var indeterminate = someOptionsSelected && !selectAllSelected;
      var optionsFoundForSearch = optionCount > 0 && searchInputValue.length;
      var showSelectAll = isAsync ? Boolean(optionsFoundForSearch || viewSelectedEnabled) : true;
      var configuredToShowSelectAll = ['all', 'select-all'].indexOf(showOptionListHeader) > -1;
      var configuredToShowViewSelected = ['all', 'view-selected'].indexOf(showOptionListHeader) > -1;
      var handleKey = function handleKey(event) {
        if (event.keyCode === 32 || event.keyCode === 13) {
          // select/Deselect all items - using Space and Enter - Key
          event.preventDefault();
          _this2.toggleSelectAll(selectAllSelected, options);
        }
      };
      var handleKeySwitch = function handleKeySwitch(event) {
        if (event.keyCode === 32 || event.keyCode === 13) {
          event.preventDefault();
          _this2.toggleViewSelected(event, !event.target.checked);
        } else if (event.keyCode === 9) {
          if (!isActionFooter) {
            event.preventDefault();
            handleChangeFocus();
          }
        }
      };
      return showOptionListHeader !== 'none' && /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        automationid: "".concat(automationid, "-option-list-header"),
        className: classes.menuItem,
        component: "div",
        "data-metrics": dataMetrics.optionListHeader,
        disableGutters: true
      }, showSelectAll && configuredToShowSelectAll && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
        automationid: "".concat(automationid, "-select-all"),
        checked: selectAllSelected,
        className: classes.multiSelectCheckbox,
        dataMetrics: {
          root: dataMetrics.selectAll
        },
        disabled: optionCount === 0,
        indeterminate: indeterminate,
        onKeyDown: function onKeyDown(event) {
          return handleKey(event);
        },
        onChange: function onChange() {
          return _this2.toggleSelectAll(selectAllSelected, options);
        }
      }), "All", " (".concat(optionCount.toLocaleString(), ") ")), configuredToShowViewSelected && /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])(classes["switch"], (0, _defineProperty2["default"])({}, classes.disabled, !someOptionsSelected))
      }, selectSwitchLabelText, /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
        automationid: "".concat(automationid, "-view-selected"),
        checked: viewSelectedEnabled,
        dataMetrics: {
          root: dataMetrics.viewSelected
        },
        disabled: !someOptionsSelected,
        onKeyDown: function onKeyDown(event) {
          return handleKeySwitch(event);
        },
        onChange: this.toggleViewSelected,
        value: "viewSelected"
      })));
    }
  }]);
  return OptionListHeader;
}(_react["default"].Component);
OptionListHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: _propTypes["default"].object,
  commonProps: _propTypes["default"].object,
  componentProps: _propTypes["default"].object,
  handleChangeFocus: _propTypes["default"].func,
  isActionFooter: _propTypes["default"].bool
} : {};
var _default = (0, _styles.withStyles)(styles)(OptionListHeader);
exports["default"] = _default;